import { render, staticRenderFns } from "./quantitiesCarousel.vue?vue&type=template&id=cbef0874&lang=pug&"
import script from "./quantitiesCarousel.vue?vue&type=script&lang=js&"
export * from "./quantitiesCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports